import { useTranslations } from "next-intl";
import { TestimonialModule as TestimonialModuleUI } from "@carfax/web-ui/components/TestimonialModule";
import { ModuleTestimonialModule } from "@carfax/contentful/PageModularModule";

const HARDCODED_TESTIMONIAL_MODULE: ModuleTestimonialModule = {
  heading: "Real buyers. Real opinions.",
  headingLevel: "h2",
  testimonials: [
    {
      text: "This is not the first time I have used your service, and in all cases I have been informed of damages or administrative seizures not reported by the seller.",
      customerName: "Verified customer",
      location: "Italy",
    },
    {
      text: "I received information that interested me, in particular the mileage, the number of owners, the lack of reported accidents, etc...",
      customerName: "Verified customer",
      location: "Italy",
    },
    {
      text: "The report was clear and detailed. It helped me make a confident decision when buying my used car.",
      customerName: "Verified customer",
      location: "Germany",
    },
    {
      text: "Great service. Fast delivery of the report and very informative content about the vehicle history.",
      customerName: "Verified customer",
      location: "France",
    },
    {
      text: "I discovered a previously undisclosed accident thanks to the CARFAX report. Definitely worth it.",
      customerName: "Verified customer",
      location: "Spain",
    },
  ],
};

interface TestimonialModuleProps {
  module?: ModuleTestimonialModule;
}

export const TestimonialModule = ({ module = HARDCODED_TESTIMONIAL_MODULE }: TestimonialModuleProps = {}) => {
  const { heading, headingLevel, testimonials, trustStats } = module;
  const t = useTranslations("common");

  return (
    <TestimonialModuleUI
      heading={heading}
      headingLevel={headingLevel}
      testimonials={testimonials}
      trustStats={trustStats}
      prevAriaLabel={t("accessibility.ariaLabelPreviousSlide")}
      nextAriaLabel={t("accessibility.ariaLabelNextSlide")}
    />
  );
};
